import { apyToAprPercent } from '../../../utils/parsing'
import { YieldFetcher } from '../../types'
import { fetchDefiLlamaApy } from './defillama'

/**
 * Tori Finance strUSD — StakedUSDeV2-style ERC-4626 over trUSD, the
 * protocol's delta-neutral synthetic dollar (money-market basis /
 * futures-arbitrage strategies, Ethereum-only). Appreciating share
 * price, no rebase; the 10% performance fee is already netted into the
 * exchange rate. Exit is the Ethena cooldown pattern verified on-chain
 * 2026-08: `cooldownDuration() = 604800` (7 days, governance-mutable),
 * `maxWithdraw = 0` while active, funds parked in the trUSD Silo
 * (`silo()` = 0xF7c0d885…) and claimed via `unstake`.
 *
 * Rate source: Tori's own app API (`/api/apy`, percent APY — its
 * `sharePrice`/`totalAssets` fields match `convertToAssets`/
 * `totalAssets()` on-chain exactly). Fallback is the DefiLlama
 * `tori-finance` pool, also a percent APY over the same share-price
 * series. Both convert to the package-wide nominal APR.
 */

const TORI_APY_URL = 'https://app.tori.finance/api/apy'
const TORI_DEFILLAMA_POOL = 'e7fdda30-ce71-5dea-8b3a-dd43de77ce55'

export const STRUSD_KEY = 'STRUSD'
/** Verified token-list assetGroup (Ethereum, the only deployment). */
export const STRUSD_GROUP_KEY = 'Tori Staked trUSD::STRUSD'

const fetchToriApyPercent = async (): Promise<number> => {
  const res = await fetch(TORI_APY_URL, {
    headers: { accept: 'application/json' },
    signal: AbortSignal.timeout(8000),
  })
  if (!res.ok) throw new Error(`HTTP ${res.status}`)
  const apy = Number((await res.json())?.apy)
  if (Number.isFinite(apy) && apy > 0) return apy
  throw new Error('apy missing')
}

export const toriFetcher: YieldFetcher = {
  label: 'STRUSD',
  fetch: async () => {
    const apy = await fetchToriApyPercent().catch(() =>
      fetchDefiLlamaApy(TORI_DEFILLAMA_POOL),
    )
    const apr = apyToAprPercent(apy)
    return { [STRUSD_KEY]: apr, [STRUSD_GROUP_KEY]: apr }
  },
}
